<template>
  <div class="header-menu-mobile-container">
    <div class="header-menu-mobile-tool">
      <span class="iconfont icon-liebiao header-menu-mobile-more"
        :class="state.openMenu ? 'header-menu-mobile-open-menu' : ''" @click="openOrCloseMenu"></span>
    </div>

    <div class="header-menu-mobile-content-container" v-if="state.openMenu" @touchmove.prevent @mousewheel.prevent>
      <div class="header-menu-mobile-navigation-item"
        :class="state.active === item.id ? 'header-menu-mobile-navigation-item-active' : ''" v-for="item in state.menu"
        :key="item.id">
        <div v-if="!item.children && item.id !== 'resource'" @click="linkTo(item)">{{ item.name }}</div>
        <a-menu v-if="item.children && item.id !== 'resource'" style="width: 100%" mode="inline" @click="handleClick">
          <a-sub-menu :key="item.id" @titleClick="titleClick(item)" class="towMenu">
            <template #title><span @click="linkTo(item)">{{ item.name }}</span> </template>
            <a-sub-menu v-for=" citem in item.children" :key="citem.id" :title="citem.name">
              <a-menu-item v-for="(ccitem, index) in getChildrenList(citem.children)" :key="ccitem.id">
                <span v-if="index < 11" @click="linkToChild(ccitem)">
                  {{ ccitem.name }}
                </span>
              </a-menu-item>
              <a-menu-item v-if="citem.children && citem.children.length > 10">
                <span style="color: #1890ff; cursor: pointer" @click="linkToChild(citem)">更多</span>

              </a-menu-item>
            </a-sub-menu>
          </a-sub-menu>
        </a-menu>
        <a-menu v-if="item.id == 'resource'" style="width: 100%" mode="inline" @click="handleClick">
          <a-sub-menu :key="item.id" @titleClick="titleClick(item)" class="towMenu">
            <template #title>{{ item.name }} </template>
            <a-menu-item key="0" @click="resourceJump('companyProfile')">
              <a>公司介绍</a>
            </a-menu-item>
            <a-menu-item key="1" @click="resourceJump('serviceNetwork')">
              <a>服务网络</a>
            </a-menu-item>
            <a-menu-item key="2" @click="resourceJump('cooperationMode')">
              <a>合作模式</a>
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </div>
    </div>

  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  watch,
  defineEmits,
  onMounted
} from 'vue'
import {
  useRouter,
  onBeforeRouteUpdate
} from 'vue-router'
import {
  MenuOutlined
} from "@ant-design/icons-vue"
import {
  NAV_CONFIG
} from "@/utils/PAGE-CONFIG.js"
import { getFilterList } from "@/api/index"

export default defineComponent({
  name: 'Menu',
  components: {
    MenuOutlined
  },
  props: {},
  emits: ['openOrCloseMenu', "openOrCloseMenu_bgc"],
  setup (props, ctx) {
    const router = useRouter()
    let state = reactive({
      menu: NAV_CONFIG,
      active: 'home',
      openMenu: false,
    })

    watch(() => router.currentRoute.value.name, (newValue, oldValue) => {
      state.active = newValue
    }, {
      immediate: true
    })

    watch(() => props.active, (newVal) => {
      state.active = newVal
    })

    const linkTo = (item) => {
      if (item.id === 'resource') {

      } else {
        state.active = item.id
        item.path && router.push(item.path)
        state.openMenu = false
      }
      ctx.emit('openOrCloseMenu_bgc', state.openMenu)
    }

    const titleClick = (item) => {
      // state.active = item.id
    }
    const handleClick = () => {
    }

    const openOrCloseMenu = () => {
      state.openMenu = !state.openMenu
      ctx.emit('openOrCloseMenu', state.openMenu)
    }
    const resourceJump = (id) => {
      let path = '/resource'
      let query = {}
      if (id === 'companyProfile') {
        query.id = 'companyProfile'
      } else if (id === 'serviceNetwork') {
        query.id = 'serviceNetwork'
      } else if (id === 'cooperationMode') {
        query.id = 'cooperationMode'
      }


      router.push({
        path: path,
        query: query
      })
      openOrCloseMenu()
    }
    const linkToChild = (item) => {
      if (item.id === "MAPaaS") {
        window.open("https://www.mapaas.com/home")
      } else if (item.children && item.children.length > 0) {
        router.push({
          path: '/product',
          query: {
            groupId: item.rowId
          }
        })
      } else {
        router.push({
          path: '/product',
          query: {
            rowId: item.rowId
          }
        })
      }
      state.openMenu = false

    }

    const getData = async () => {
      let params = {
        page: 1,
        pageSize: 100,
        sortField: "number84ecee89",
        isAsc: false,
        worksheetId: "680f485b88d915058691f9de",
      }
      const res = await getFilterList(params)
      if (res.code === 200 && res.data && res.data.length > 0) {
        state.menu[1].children = res.data
        res.data.forEach(item => {
          item.name = item.input988275a1
          if (item.input988275a1 === "零代码产品") {
            item.children = [
              {
                id: "MAPaaS",
                name: "畅图云",
              }
            ]
          } else {
            if (item.associationFieldsb2d1b102) {
              item.children = item.associationFieldsb2d1b102.map(val => {
                return {
                  id: val.rowId,
                  name: val.input988275a1,
                  rowId: val.rowId
                }
              })
            }
          }
        })

      }


    }

    const getChildrenList = (list) => {
      if (list && list.length > 10) {
        return list.slice(0, 11)
      } else {
        return list
      }
    }
    onMounted(() => {
      getData()
    })
    return {
      state,
      linkTo,
      openOrCloseMenu,
      titleClick,
      handleClick,
      resourceJump,
      linkToChild,
      getChildrenList
    }
  }
})

</script>

<style scoped>
.header-menu-mobile-container {
  display: inline-block;
  margin: auto 10px;
}

.header-menu-mobile-tool {
  height: 100%;
  display: flex;
  align-items: center;
}

.header-menu-mobile-more {
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
}


.header-menu-mobile-open-menu {
  color: #2081EB;
}

.header-menu-mobile-content-container {
  position: fixed;
  z-index: 16;
  top: 65px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: #fff;
  ;
  width: calc(100% + 1px);
}

.header-menu-mobile-navigation-item {
  font-size: 15px;
  font-weight: 600;
  line-height: 53px;
  /* border-bottom: 1px solid #DDDDDD; */
  cursor: pointer;
}

.header-menu-mobile-navigation-item>div {
  padding: 0 10px;
}

.header-menu-mobile-navigation-item-active {
  color: #2081EB;
  /* border-color: #2081EB; */
}

.header-navigation-item-dropdown {
  height: 53px;
  width: 100%;
  /* position: absolute;
  top: 210px; */
}

.ant-dropdown-content .ant-dropdown-menu {
  margin-top: -20px;
  margin-left: 30px;
}
</style>

<style>
.towMenu .ant-menu-submenu-title {
  padding-left: 10px !important;
  font-size: 15px;
  font-weight: 600;
  line-height: 53px;
}

.towMenu .ant-menu-submenu {
  padding-left: 38px !important;
}

.towMenu .ant-menu-submenu-selected {
  color: rgba(32, 129, 235, 1) !important;
}

.towMenu .ant-menu-light .ant-menu-item:hover,
.ant-menu-light .ant-menu-item-active,
.ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-light .ant-menu-submenu-active,
.ant-menu-light .ant-menu-submenu-title:hover {
  color: rgba(32, 129, 235, 1) !important;
}

.towMenu .ant-menu-vertical .ant-menu-item::after,
.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-inline .ant-menu-item::after {
  border-right: none !important;
}

.towMenu .ant-menu-item-selected {
  color: rgba(32, 129, 235, 1) !important;
  ;
}

.towMenu .ant-menu-item {
  padding-left: 50px !important;
}

.towMenu .ant-menu-submenu:hover>.ant-menu-submenu-title>.ant-menu-submenu-expand-icon,
.ant-menu-submenu:hover>.ant-menu-submenu-title>.ant-menu-submenu-arrow {
  color: rgba(32, 129, 235, 1) !important;
}

.towMenu .ant-menu-item-only-child {
  font-size: 2.6rem;
  font-weight: 400;
  color: #6B7487;
}
</style>
